import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppRouter from './routes';

ReactDOM.render(<AppRouter/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js